import React from 'react';
import { Paper } from '@mui/material';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PropTypes from 'prop-types';

const PageHeader = ({ back = true, close = true, text, handleBack, handleClose, }) => {
    return (
        <Paper sx={{ background: 'transparent', borderRadius: '0' }} elevation={0} className='flex justify-between items-center p-4 bg-primary'>
            {back && <ArrowBackIcon onClick={handleBack} className='text-white' />}
            {text && <div className='text-white text-base uppercase font-bold'>
                {text}
            </div>}
            {close && <CloseOutlinedIcon onClick={handleClose} className='text-white' />}
        </Paper>
    );
};

PageHeader.propTypes = {
    back: PropTypes.bool,
    close: PropTypes.bool,
    text: PropTypes.string,
    handleBack: PropTypes.func,
    handleClose: PropTypes.func
};

export default PageHeader;
